import React from "react";

import "./Options.css";

const Options = (props) => {

  const optionsInjured = [
    {
      text: "Da",
      handler: props.actionProvider.handleInjuredYes,
      id: 1,
    },
    { 
      text: "Ne",
      handler: props.actionProvider.handleInjuredNo,
      id: 2,
    }
  ];

  const optionsLocations = [
    {
      text: "Vojvodina",
      handler: props.actionProvider.handleVojvodina,
      id: 1,
    },
    { 
      text: "Zapadna Srbija",
      handler: props.actionProvider.handleZapadnaSrbija,
      id: 2,
    },
    { 
      text: "Centralna Srbija",
      handler: props.actionProvider.handleCentralnaSrbija,
      id: 3,
    },
    { 
      text: "Južna/Istočna Srbija",
      handler: props.actionProvider.handleJuznaIstocnaSrbija,
      id: 4,
    }
  ];

  const getOps = () => {
    if (props.ops === 'optionsLocations')
      return optionsLocations;
    if (props.ops === 'optionsInjured')
      return optionsInjured;
    return optionsInjured;
  }

  let group = getOps();


  const buttonsMarkup = 
    group.map((option) => (
    <button key={option.id} onClick={option.handler} className="option-button">
      {option.text}
    </button>
  ));

  return <div className="options-container">
      {/* <div>{JSON.stringify(props.ops)}</div> */}
      {buttonsMarkup}
    </div>;
};

export default Options;
